import Fcontent1 from "./features/Fcontent1";
import Ffeatures8 from "./features/Ffeatures8";
import Fcontent3 from "./features/Fcontent3";
import Fcta3 from "./features/Fcta3";

const FeaturesPage = () => {
    return (
        <>
            <Fcontent1 />
            <Ffeatures8 />
            <Fcontent3 />
            <Fcta3 />
        </>
    );
};

export default FeaturesPage;
